/* ─────────────────────────────────────────────────────
   Mekeni Theme — mekeni.js
   Loaded deferred in layout/theme.liquid
   ───────────────────────────────────────────────────── */

/* ── 0. Page transition overlay ── */
(function initPageTransition() {
  var overlay = document.getElementById('page-transition');
  if (!overlay) return;

  /* Fade out on load */
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      overlay.classList.add('is-out');
    });
  });

  /* Safari/iOS back-forward cache restores the page exactly as it was
     left — with the overlay faded IN from the outbound transition.
     pageshow fires on bfcache restores (load does not); clear it. */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) overlay.classList.add('is-out');
  });

  /* Fade in before navigating away */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href]');
    if (!link) return;

    var href = link.getAttribute('href');
    if (!href || href.charAt(0) === '#') return;
    if (link.target === '_blank') return;
    if (/^(mailto:|tel:)/.test(href)) return;

    /* Only intercept same-origin navigation */
    try {
      var dest = new URL(href, window.location.origin);
      if (dest.origin !== window.location.origin) return;
    } catch (_) { return; }

    e.preventDefault();
    overlay.classList.remove('is-out');
    setTimeout(function () {
      window.location.href = href;
    }, 300);
  });
})();

/* ── 1. Nav drawer ── */
(function initDrawer() {
  var overlay = document.getElementById('nav-drawer');
  if (!overlay) return;

  function openDrawer() {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-action="open-drawer"]').forEach(function(btn) {
    btn.addEventListener('click', openDrawer);
  });

  document.querySelectorAll('[data-action="close-drawer"]').forEach(function(btn) {
    btn.addEventListener('click', closeDrawer);
  });

  /* Click on scrim (not on the drawer itself) */
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) closeDrawer();
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeDrawer();
  });
})();

/* ── 2. Search overlay + predictive search ── */
(function initSearch() {
  var overlay = document.getElementById('search-overlay');
  var input   = document.getElementById('search-input');
  var results = document.getElementById('search-results');
  if (!overlay || !input || !results) return;

  var debounceTimer;

  function openSearch() {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    /* Delay focus so transition is visible */
    setTimeout(function() { input.focus(); }, 80);
  }

  function closeSearch() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    input.value = '';
    results.innerHTML = '';
  }

  document.querySelectorAll('[data-action="open-search"]').forEach(function(btn) {
    btn.addEventListener('click', openSearch);
  });

  document.querySelectorAll('[data-action="close-search"]').forEach(function(btn) {
    btn.addEventListener('click', closeSearch);
  });

  overlay.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeSearch();
  });

  function esc(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  var latestQuery = '';

  function searchAllLink(q) {
    return '<li><a href="/search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last" class="search-result-item search-result-item--all">' +
      '<span class="search-result-item__text">' +
        '<span class="search-result-item__sub">Search for &ldquo;' + esc(q) + '&rdquo; &rarr;</span>' +
      '</span></a></li>';
  }

  function fetchSuggestions(q) {
    latestQuery = q;
    if (q.length < 2) { results.innerHTML = ''; return; }
    fetch(
      '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=6' +
      '&resources[options][fields]=title,product_type,variants.title' +
      '&resources[options][prefix]=last'
    )
      .then(function(r) { return r.json(); })
      .then(function(data) {
        /* Ignore stale responses that resolve after a newer query */
        if (q !== latestQuery) return;
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!products.length) {
          results.innerHTML =
            '<li class="search-no-results">' +
              '<span class="search-no-results__head">No results</span>' +
              '<span class="search-no-results__sub">Nothing found for “' + esc(q) + '”</span>' +
            '</li>';
        } else {
          renderResults(products, q);
        }
      })
      .catch(function() { results.innerHTML = ''; });
  }

  function renderResults(products, q) {
    results.innerHTML = products.map(function(p) {
      var imgUrl = '';
      if (p.metafields && p.metafields.custom && p.metafields.custom.internal_search_image) {
        imgUrl = p.metafields.custom.internal_search_image;
      } else if (p.featured_image && p.featured_image.url) {
        imgUrl = p.featured_image.url;
      }
      var img = imgUrl
        ? '<img src="' + esc(imgUrl) + '" alt="" class="search-result-item__image" width="40" height="52" loading="lazy">'
        : '';
      var variant = (p.variants && p.variants[0] && p.variants[0].title && p.variants[0].title !== 'Default Title')
        ? p.variants[0].title : '';
      var sub = [p.product_type, variant].filter(Boolean).join(' · ');
      return '<li><a href="' + esc(p.url) + '" class="search-result-item">' +
        '<span class="search-result-item__text">' +
          '<span class="search-result-item__name">' + esc(p.title) + '</span>' +
          (sub ? '<span class="search-result-item__sub">' + esc(sub) + '</span>' : '') +
        '</span>' +
        img +
        '</a></li>';
    }).join('') + searchAllLink(q);
  }

  input.addEventListener('input', function() {
    clearTimeout(debounceTimer);
    var q = this.value.trim();
    debounceTimer = setTimeout(function() { fetchSuggestions(q); }, 200);
  });

  /* ── Keyboard navigation (Dawn-style): arrows move through results,
     Enter opens the highlighted one, plain Enter submits to /search ── */
  var selectedIndex = -1;

  function highlightResult(items, idx) {
    items.forEach(function(a, i) {
      a.classList.toggle('is-selected', i === idx);
      a.setAttribute('aria-selected', i === idx ? 'true' : 'false');
    });
    if (idx >= 0 && items[idx]) items[idx].scrollIntoView({ block: 'nearest' });
  }

  input.addEventListener('keydown', function(e) {
    var items = Array.from(results.querySelectorAll('a.search-result-item'));
    if (!items.length) return;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      selectedIndex = (selectedIndex + 1) % items.length;
      highlightResult(items, selectedIndex);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      selectedIndex = selectedIndex <= 0 ? items.length - 1 : selectedIndex - 1;
      highlightResult(items, selectedIndex);
    } else if (e.key === 'Enter' && selectedIndex >= 0 && items[selectedIndex]) {
      e.preventDefault();
      window.location.href = items[selectedIndex].href;
    }
  });

  input.addEventListener('input', function() { selectedIndex = -1; });
})();

/* ── 2a. Frame 1 color cycle (sunshell + wordmark) ──
   JS rAF clock (not CSS keyframes) loops `fill` through the three brand
   tones at SUN_COLOR_HZ. Both elements share one synchronized clock. */
(function initIntroColorCycle() {
  var frame = document.getElementById('intro-frame');
  if (!frame || frame.dataset.colorShift !== 'true') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var targets = frame.querySelectorAll('.intro-shell .cls-1, .intro-wordmark .cls-1');
  if (!targets.length) return;

  var SUN_COLOR_HZ = 0.26;
  var SUN_COLORS = [
    frame.getAttribute('data-cycle-color-1') || '#E7B537',
    frame.getAttribute('data-cycle-color-2') || '#A3B877',
    frame.getAttribute('data-cycle-color-3') || '#FFFCF0'
  ];
  /* Parse via a 1x1 canvas rather than assuming #RRGGBB — the theme
     editor's color picker can output hex, rgb(), or rgba() depending on
     whether the merchant touched the opacity slider. */
  var parseCanvas = document.createElement('canvas');
  parseCanvas.width = parseCanvas.height = 1;
  var parseCtx = parseCanvas.getContext('2d');
  var SUN_RGB = SUN_COLORS.map(function(c) {
    parseCtx.clearRect(0, 0, 1, 1);
    parseCtx.fillStyle = c;
    parseCtx.fillRect(0, 0, 1, 1);
    var d = parseCtx.getImageData(0, 0, 1, 1).data;
    return [d[0], d[1], d[2]];
  });

  function cycleColor(t) {
    var n = SUN_RGB.length;
    var f = ((t % n) + n) % n;
    var i0 = Math.floor(f) % n, i1 = (i0 + 1) % n, k = f - Math.floor(f);
    var a = SUN_RGB[i0], b = SUN_RGB[i1];
    return 'rgb(' +
      Math.round(a[0] + (b[0] - a[0]) * k) + ',' +
      Math.round(a[1] + (b[1] - a[1]) * k) + ',' +
      Math.round(a[2] + (b[2] - a[2]) * k) + ')';
  }

  var t0 = null;
  function tick(now) {
    if (t0 === null) t0 = now;
    var time = (now - t0) / 1000;
    var color = cycleColor(time * SUN_COLOR_HZ);
    for (var i = 0; i < targets.length; i++) {
      targets[i].style.fill = color;
    }
    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
})();

/* ── 2b. Frame 1 (intro) — fade-out + scroll-hint, via shared coordinator ──
   Fade starts on the very first scroll pixel (ip=0) and completes at
   ip=0.5 (50vh). Previously used clamp((ip-0.5)/0.5) which held the
   intro fully opaque for the first 50vh — a noticeable dead zone.
   The "Scroll" hint fades out over just the first 30% of the budget. */
(function initIntroFade() {
  var intro = document.getElementById('intro-frame');
  var hint  = document.getElementById('intro-scroll-hint');
  if (!intro || !window.MekeniScroll) return;

  var clamp = window.MekeniScroll.clamp;

  /* On the homepage, mekeni-bottle-animation-v3.js drives the header's
     opacity/visibility itself (tied to its own hero's scroll progress,
     p=0.88->1.0, so hero + header fade in together). Only take over
     header reveal here when that section isn't present — i.e. Intro
     Frame used standalone (no Bottle Animation v3 alongside it), so it
     still gets a working reveal instead of staying invisible forever. */
  var header = document.querySelector('.site-header');
  var driveHeader = header && !document.getElementById('bottle-anim-section');

  window.MekeniScroll.subscribe(function (s) {
    var introFade = clamp(s.ip / 0.5, 0, 1);
    var opacity = 1 - introFade;

    intro.style.opacity = String(opacity);
    if (introFade >= 1) {
      intro.style.pointerEvents = 'none';
      intro.style.visibility    = 'hidden';
    } else {
      intro.style.pointerEvents = '';
      intro.style.visibility    = '';
    }

    if (hint) {
      hint.style.opacity = String(clamp(1 - s.ip / 0.3, 0, 1));
    }

    if (driveHeader) {
      header.style.opacity       = String(introFade);
      header.style.visibility    = introFade > 0 ? 'visible' : 'hidden';
      header.style.pointerEvents = introFade > 0.5 ? 'auto' : 'none';
    }
  });
})();

/* initHeaderScroll removed — header is now driven by mekeni-bottle-animation.js
   via heroFade (p=0.88→1.0) so both hero and header fade in together, OR by
   initIntroFade above when Intro Frame is used without Bottle Animation v3. */

/* ── 3. Hero — copy panel (left) + CTA panel (right) entrances ──
   Both are driven by scroll progress p. Copy (h2 + subcopy) enters
   from the left; CTA enters from the right with a slight delay.
   Easing approximates cubic-bezier(0.22, 0.61, 0.36, 1). */
(function initHeroScroll() {
  var copyPanel = document.getElementById('hero-copy-panel');
  var ctaPanel  = document.getElementById('hero-cta-panel');
  if (!window.MekeniScroll) return;

  var clamp = window.MekeniScroll.clamp;
  var lerp  = window.MekeniScroll.lerp;

  /* Ease-out cubic approximating cubic-bezier(0.22, 0.61, 0.36, 1) */
  function easeOut(t) { return 1 - Math.pow(1 - t, 3); }

  window.MekeniScroll.subscribe(function (s) {
    var p = s.p;

    /* Copy panel: h2 + subcopy — enter from left */
    if (copyPanel) {
      var navP = clamp((p - 0.25) / 0.75, 0, 1);
      var ep   = easeOut(navP);
      copyPanel.style.opacity       = String(ep);
      copyPanel.style.transform     = 'translate(' + lerp(-28, 0, ep) + 'px, -50%)';
      copyPanel.style.pointerEvents = ep > 0.5 ? 'auto' : 'none';
      copyPanel.style.visibility    = ep > 0 ? 'visible' : 'hidden';
    }

    /* CTA panel — enter from right, 7% later start */
    if (ctaPanel) {
      var navP_btn = clamp((p - 0.32) / 0.68, 0, 1);
      var ep_btn   = easeOut(navP_btn);
      /* opacity < 1 on the panel disables the CTA's backdrop-filter */
      ctaPanel.style.opacity       = ep_btn >= 0.85 ? '1' : String(ep_btn);
      ctaPanel.style.transform     = 'translate(' + lerp(28, 0, ep_btn) + 'px, -50%)';
      ctaPanel.style.pointerEvents = ep_btn > 0.5 ? 'auto' : 'none';
      ctaPanel.style.visibility    = ep_btn > 0 ? 'visible' : 'hidden';
    }
  });
})();

/* ── 5. Contact form validation ── */
(function initContactForm() {
  var form = document.getElementById('ContactForm');
  if (!form) return;

  function checkEmpty() {
    return Array.prototype.some.call(form.querySelectorAll('[required]'), function (f) {
      return f.value.trim() === '';
    });
  }

  form.addEventListener('submit', function (e) {
    var hasEmpty = checkEmpty();
    form.classList.toggle('form-has-errors', hasEmpty);
    if (hasEmpty) {
      e.preventDefault();
      /* Re-evaluate on every keystroke until no empties remain */
      form.querySelectorAll('[required]').forEach(function (f) {
        f.addEventListener('input', function () {
          form.classList.toggle('form-has-errors', checkEmpty());
        });
      });
    }
  });
})();

/* ── 5a. Footer email signup — Klaviyo mode ──
   Only activates when the form has data-signup-mode="klaviyo".
   Shopify native mode is handled server-side via form.posted_successfully? */
(function initFooterSignup() {
  var wrap = document.getElementById('footer-signup');
  if (!wrap) return;
  var form = wrap.querySelector('[data-signup-mode="klaviyo"]');
  if (!form) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var emailInput = form.querySelector('input[type="email"]');
    if (!emailInput || !emailInput.value.trim()) return;

    var data = new FormData(form);

    fetch(form.action, {
      method: 'POST',
      body: data,
      headers: { 'Accept': 'application/json' }
    })
      .then(function () {
        wrap.innerHTML =
          '<p class="footer-signup__success">Salamat — you\'re on the list.</p>';
      })
      .catch(function () {
        /* Silent fail — Klaviyo CORS can block the response even on success.
           Swap to success state regardless, since the subscription goes through. */
        wrap.innerHTML =
          '<p class="footer-signup__success">Salamat — you\'re on the list.</p>';
      });
  });
})();

/* ── 6. Footer accordion (mobile) ── */
(function initFooterAccordion() {
  document.querySelectorAll('.footer-col__toggle').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var col      = this.closest('.footer-col');
      var expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', String(!expanded));
      if (col) col.classList.toggle('is-open', !expanded);
    });
  });
})();

/* ── 7. Newsletter teaser — dock above the footer instead of overlapping it ──
   The Shopify Forms app's floating teaser is position:fixed deep inside a
   <shopify-forms-embed> element's shadow root, so a plain CSS rule from
   our stylesheet can't reach it (shadow DOM encapsulation). Its shadow
   root is open, though, so we can poll for the corner-docked teaser and
   nudge it up via inline style, using window.MekeniScroll's shared rAF
   loop rather than a second scroll listener.

   Deliberately defensive: bails out silently (never touches anything)
   unless the widget matches the exact "fixed, bottom-anchored corner
   teaser" shape we've observed — a merchant switching the app's layout
   to a modal/center popup, or Shopify changing the app's internals,
   should just mean this enhancement quietly does nothing rather than
   risk breaking the widget itself. */
(function initNewsletterTeaserFooterDock() {
  var footer = document.querySelector('.site-footer');
  if (!footer || !window.MekeniScroll) return;

  var attempts = 0;
  var MAX_ATTEMPTS = 40; // ~12s at 300ms

  function findTeaser() {
    var host = document.querySelector('shopify-forms-embed');
    if (!host || !host.shadowRoot) return null;
    var el = host.shadowRoot.getElementById('app-embed');
    if (!el) return null;
    var cs = getComputedStyle(el);
    if (cs.position !== 'fixed' || cs.bottom === 'auto') return null;
    return el;
  }

  function poll() {
    var teaser = findTeaser();
    if (teaser) {
      attach(teaser);
      return;
    }
    attempts++;
    if (attempts < MAX_ATTEMPTS) setTimeout(poll, 300);
  }

  function attach(teaser) {
    var baseBottom = parseFloat(getComputedStyle(teaser).bottom) || 0;
    window.MekeniScroll.subscribe(function () {
      var rect = footer.getBoundingClientRect();
      var overlap = window.innerHeight - rect.top;
      var lift = overlap > 0 ? Math.min(overlap, rect.height) : 0;
      teaser.style.bottom = (baseBottom + lift) + 'px';
    });
  }

  poll();
})();
